(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b21-newsletter-popup"]) return;
  try {
    
  (()=>{
    const key='b21-newsletter-popup-v1';
    function setup(){
      const dialog=document.querySelector('[data-b21-newsletter]');
      if(!dialog||dialog.dataset.ready)return;
      dialog.dataset.ready='true';
      let timer,oldOverflow,previousFocus;
      const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'null')}catch{return null}};
      const write=value=>{try{localStorage.setItem(key,JSON.stringify(value))}catch{}};
      const open=()=>{if(dialog.open)return;if(document.querySelector('dialog[open]')){timer=setTimeout(open,2000);return}previousFocus=document.activeElement;oldOverflow=document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow='hidden'};
      const close=()=>dialog.close();
      dialog.querySelectorAll('[data-newsletter-close]').forEach(button=>button.addEventListener('click',close));
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close()});
      dialog.addEventListener('close',()=>{clearTimeout(timer);document.documentElement.style.overflow=oldOverflow||'';if(!dialog.querySelector('[data-newsletter-success]'))write({dismissed:Date.now()});previousFocus?.focus?.()});
      dialog.addEventListener('cancel',()=>clearTimeout(timer));
      if(dialog.querySelector('[data-newsletter-success]')){write({subscribed:true});open();return}
      if(dialog.querySelector('[data-newsletter-error]')){open();return}
      const state=read();
      if(window.Shopify?.designMode){open();return}
      if(state?.subscribed||state?.dismissed&&Date.now()-state.dismissed<7*86400000)return;
      if(!location.pathname.includes('/cart'))timer=setTimeout(open,Number(dialog.dataset.delay)||8000);
    }
    setup();document.addEventListener('shopify:section:load',setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
